import { render, staticRenderFns } from "./ComparePackages.vue?vue&type=template&id=508bfa31&scoped=true&"
import script from "./ComparePackages.vue?vue&type=script&lang=js&"
export * from "./ComparePackages.vue?vue&type=script&lang=js&"
import style0 from "./ComparePackages.vue?vue&type=style&index=0&id=508bfa31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508bfa31",
  null
  
)

export default component.exports